<template>
  <div id="add-project">
    <!-- page header component -->
    <div class="bg-white shade py-2 px-3 mb-4" style="margin-top: 15px">
      <h3 style="font-size: 20px">
        <router-link to="/admin/dashboard">
          <i class="bi bi-arrow-left"></i>
        </router-link>
        {{ nama_proyek }}
      </h3>
    </div>
    <!-- detail project component -->
    <div class="row mb-4">
      <div class="col-md-12 px-3">
        <div class="bg-white p-l-20 p-t-10 p-r-20 p-b-20 shade">
          <div class="row" v-if="project">
            <div
              class="col-md-2"
              style="
                margin-left: auto;
                margin-right: auto;
                text-align: center;
                display: table-cell;
                vertical-align: middle;
                padding: 15px 25px;
              "
            >
              <img
                v-if="project"
                :src="logo_project"
                alt=""
                style="width: 100%"
              />
              <div style="margin-top: 10px">
                <button
                  aria-label=""
                  @click="ubahGambar"
                  type="button"
                  class="btn btn-outline-complete"
                >
                  Ubah Gambar
                </button>
                <input
                  type="file"
                  name="file"
                  @change="previewFile"
                  class="hide"
                  id="logo_proyek"
                  value=""
                  placeholder="Ubah Gambar"
                />
              </div>
            </div>
            <div class="col-md-6">
              <h4>Detail Project #{{ project.project_detail._id }}</h4>
              <form
                class="form-horizontal"
                role="form"
                autocomplete="off"
                novalidate="novalidate"
                v-on:submit.prevent="submitForm"
              >
                <div class="form-group row">
                  <label for="name" class="col-md-2 control-label"
                    >Nama Project</label
                  >
                  <div class="col-md-10">
                    <input
                      type="text"
                      name="name"
                      v-model="project.project_detail.name"
                      value=""
                      placeholder=""
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="alias" class="col-md-2 control-label"
                    >Alias</label
                  >
                  <div class="col-md-10">
                    <input
                      type="text"
                      name="alias"
                      v-model="project.project_detail.alias"
                      value=""
                      placeholder=""
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="tipe" class="col-md-2 control-label"
                    >Versi Aplikasi</label
                  >
                  <div class="col-md-10">
                    <select
                      name="tipe"
                      id="tipe"
                      v-model="project.project_detail.tipe"
                      class="form-control"
                      required
                    >
                      <option value="1">KURASI</option>
                      <option value="2">KABAYAN</option>
                      <option value="3">DIGIVLA</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="category" class="col-md-2 control-label">
                    Kategori Project
                  </label>
                  <div class="col-md-10">
                    <select
                      name="category"
                      id="category"
                      v-model="project.project_detail.category"
                      class="form-control"
                      required
                    >
                      <option value="GOVERMENT/PEMDA">GOVERMENT/PEMDA</option>
                      <option value="BRAND">BRAND</option>
                      <option value="BUMN">BUMN</option>
                      <option value="APH">APH</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="tier" class="col-md-2 control-label"
                    >Tier Project</label
                  >
                  <div class="col-md-10">
                    <select
                      name="tier"
                      id="tier"
                      v-model="project.project_detail.tier"
                      class="form-control"
                      required
                    >
                      <option value="A"> Tier A</option>
                      <option value="B"> Tier B</option>
                      <option value="C"> Tier C</option>
                      <option value="D"> Tier D</option>
                      <option value="E"> Tier E</option>
                      <option value="F"> Tier F</option>
                    </select>
                  </div>
                </div>
                <div
                  class="form-group row"
                  v-if="project.project_detail.tipe == 1"
                >
                  <label for="jenis-subscribe" class="col-md-2 control-label"
                    >Jenis Subscribe</label
                  >
                  <div class="col-md-10">
                    <select
                      name="display_tipe"
                      id="display_tipe"
                      v-model="project.project_detail.display_tipe"
                      class="form-control"
                      required
                      :disabled="project.project_detail.status == 0"
                    >
                      <option value="1">Data Media Sosial</option>
                      <option value="2">Data Media Konvensional</option>
                      <option value="3">
                        Data Media Sosial dan Media Konvensional
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="periode_project" class="col-md-2 control-label"
                    >Periode Project</label
                  >
                  <div class="col-md-10">
                    <div
                      id="periode_project"
                      style="
                        background: #fff;
                        cursor: pointer;
                        padding: 5px 10px;
                        border: 1px solid #ccc;
                        border-radius: 5px;
                        width: 100%;
                      "
                    >
                      <i class="bi bi-calendar-event m-r-15"></i>&nbsp;
                      <span></span>
                      <i class="bi bi-caret-down-fill"></i>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="name" class="col-md-2 control-label"
                    >Limit Keyword</label
                  >
                  <div class="col-md-10">
                    <input
                      type="text"
                      name="name"
                      v-model="project.project_detail.keyword_limit"
                      placeholder=""
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="status_project" class="col-md-2 control-label"
                    >Status</label
                  >
                  <div class="col-md-10">
                    <select
                      name="status_project"
                      id="status_project"
                      v-model="project.project_detail.status"
                      class="form-control"
                      required
                    >
                      <option value="0">Stopped</option>
                      <option value="1">Running</option>
                      <option value="2">Trial</option>
                      <option value="3">Pending</option>
                      <option value="4">Development</option>
                      <option value="5">On Premise</option>
                    </select>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-md-10">
                    <button
                      v-if="allow_delete"
                      @click="deleteProject"
                      aria-label=""
                      class="btn btn-danger btn-icon-left"
                      type="button"
                    >
                      <i class="bi bi-trash"></i> Hapus Project
                    </button>
                  </div>
                  <div class="col-md-2">
                    <button
                      aria-label=""
                      class="btn btn-success pull-right"
                      type="submit"
                    >
                      Simpan
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-3">
              <h4>Fitur</h4>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    :checked="project.project_detail.sna"
                    id="pagesSwitchSNA"
                    @click="toggleSNA"
                  />
                  <label for="pagesSwitchSNA" class="full-width">
                    <i class="bi bi-share-fill"></i> Social Network Analytic
                    (SNA)
                  </label>
                </div>
              </div>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    :checked="project.project_detail.ner"
                    id="pagesSwitchNER"
                    @click="toggleNER"
                  />
                  <label for="pagesSwitchNER" class="full-width">
                    <i class="bi bi-bezier"></i> NER & NEA
                  </label>
                </div>
              </div>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    :checked="project.project_detail.quotes_extraction"
                    id="pagesSwitchQuote"
                    @click="toggleQuote"
                  />
                  <label for="pagesSwitchQuote" class="full-width">
                    <i class="bi bi-chat-quote"></i> Quote Extraction
                  </label>
                </div>
              </div>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    :checked="project.project_detail.twitter_trending"
                    id="pagesSwitchTrending"
                    @click="toggleTrending"
                  />
                  <label for="pagesSwitchTrending" class="full-width">
                    <i class="bi bi-twitter icon-sidebar"></i> Twitter Trending
                    Topic
                  </label>
                </div>
              </div>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    :checked="project.project_detail.cc"
                    id="pagesSwitchCC"
                    @click="toggleCC"
                  />
                  <label for="pagesSwitchCC" class="full-width">
                    <i class="bi bi-code-slash"></i> DIGIVLA API
                  </label>
                </div>
              </div>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    id="switchNewsTrendDetail"
                    :checked="project.project_detail.news_trend"
                    @click="toggleNewsTrend"
                  />
                  <label for="switchNewsTrendDetail" class="full-width">
                    <i class="bi bi-graph-up-arrow"></i> News Trend
                  </label>
                </div>
              </div>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    id="switchIGComment"
                    :checked="
                      'features' in project.project_detail
                        ? project.project_detail.features.ig_comment
                        : false
                    "
                    @click="toggleIG"
                  />
                  <label for="switchIGComment" class="full-width">
                    <i class="bi bi-instagram icon-sidebar"></i> Instagram
                    Comment
                  </label>
                </div>
              </div>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    id="switchSearch"
                    :checked="
                      'features' in project.project_detail
                        ? project.project_detail.features.search
                        : false
                    "
                    @click="toggleSearch"
                  />
                  <label for="switchSearch" class="full-width">
                    <i class="bi bi-search"></i> Search
                  </label>
                </div>
              </div>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    id="switchGoogleSearch"
                    :checked="
                      'features' in project.project_detail
                        ? project.project_detail.features.search_google
                        : false
                    "
                    @click="toggleGoogleSearch"
                  />
                  <label for="switchGoogleSearch" class="full-width">
                    <i class="bi bi-google"></i> Google Search
                  </label>
                </div>
              </div>
              <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
                <div
                  class="form-check switch switch-lg complete full-width right d-flex m-b-0"
                >
                  <input
                    type="checkbox"
                    id="switchV6Access"
                    :checked="
                      'features' in project.project_detail
                        ? project.project_detail.features.v6_access
                        : false
                    "
                    @click="toggleV6Access"
                  />
                  <label for="switchV6Access" class="full-width">
                    <i class="bi bi-columns-gap"></i> Akses Dashboard V6
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row m-t-10">
      <div class="col-md-12">
        <div class="bg-white p-l-20 p-t-10 p-r-20 p-b-20 shade">
          <div class="form-add m-t-10">
            <div class="row">
              <div class="col-md-12">
                <tab-horizontal-component v-if="project" :tabs="tabs" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <floating-loader-component
      v-if="is_loading"
      :key="loading_key"
      :text="loading_text"
    />
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import tab_horizontal from "@/views/components/tab_horizontal.vue";
import tab_keyword from "@/views/components/super-admin/detail-project/tab_keyword.vue";
import tab_user from "@/views/components/super-admin/detail-project/tab_user.vue";
import tab_sources from "@/views/components/super-admin/detail-project/tab_sources.vue";
import modal_log from "@/views/components/super-admin/detail-project/modal_log.vue";
import swal from "sweetalert";
import notif from "@/assets/js/notif.js";
import floating_loader from "@/views/components/floating_loader.vue";
$.pgNotification = notif;

function initDaterangeFilter2(start, end) {
  $(function() {
    if (start == null && end == null) {
      start = moment();
      end = moment().add(30, "days");
    } else {
      start = moment(start);
      end = moment(end);
    }

    function cb(start, end, def_value) {
      if (def_value != "Custom Range") {
        $("#periode_project span").html(
          start.format("D MMM YYYY 00:00") +
            " - " +
            end.format("D MMM YYYY 23:59")
        );
      } else {
        $("#periode_project span").html(
          start.format("D MMM YYYY HH:mm") +
            " - " +
            end.format("D MMM YYYY HH:mm")
        );
      }
    }
    var dateRange = {};
    dateRange["30 Hari"] = [
      moment().format("D MMM YYYY 00:00"),
      moment()
        .add(30, "days")
        .format("D MMM YYYY 23:59"),
    ];
    dateRange["60 Hari"] = [
      moment().format("D MMM YYYY 00:00"),
      moment()
        .add(60, "days")
        .format("D MMM YYYY 23:59"),
    ];
    dateRange["90 Hari"] = [
      moment().format("D MMM YYYY 00:00"),
      moment()
        .add(90, "days")
        .format("D MMM YYYY 23:59"),
    ];
    dateRange["6 Bulan"] = [
      moment().format("D MMM YYYY 00:00"),
      moment()
        .add(6, "month")
        .format("D MMM YYYY 23:59"),
    ];
    dateRange["1 Tahun"] = [
      moment().format("D MMM YYYY 00:00"),
      moment()
        .add(1, "year")
        .format("D MMM YYYY 23:59"),
    ];
    $("#periode_project").daterangepicker(
      {
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        startDate: start,
        endDate: end,
        ranges: dateRange,
        timePickerIncrement: 10,
        opens: "right",
        drops: "auto",
        locale: {
          format: "DD MMM YYYY HH:mm",
        },
      },
      cb
    );
    cb(start, end, "default");
  });
}

export default {
  name: "DetailProject",
  title: "Detail Project | Online Media Monitoring",
  components: {
    "tab-horizontal-component": tab_horizontal,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      id_project: this.$route.query.ref ? atob(this.$route.query.ref) : null,
      project: null,
      tabs: {},
      allow_delete: false,
      is_loading: false,
      loading_key: 0,
      loading_text: "",
      file_input: null,
      setnotifv6: false, 
    };
  },
  methods: {
    submitForm: function() {
      this.is_loading = true;
      this.uploadFile().then((filename) => {
        this.loading_text = "Menyimpan perubahan...";
        this.loading_key++;
        let periode = $("#periode_project span").html();
        periode = periode.split(" - ");
        let periode_from = moment(periode[0].trim()).format(
          "YYYY-MM-D HH:mm:ss"
        );
        let periode_to = moment(periode[1].trim()).format("YYYY-MM-D HH:mm:ss");
        let logo = this.project.project_detail.logo;
        if (filename != null) {
          logo = filename;
        }
        let param = {
          _id: this.project.project_detail._id,
          name: this.project.project_detail.name,
          username: this.$store.getters.user.user,
          alias: this.project.project_detail.alias,
          logo: logo,
          status: parseInt(this.project.project_detail.status),
          tipe: parseInt(this.project.project_detail.tipe),
          category: this.project.project_detail.category,
          tier: this.project.project_detail.tier,
          display_tipe: this.project.project_detail.display_tipe
            ? parseInt(this.project.project_detail.display_tipe)
            : 0,
          periode_from: periode_from,
          periode_to: periode_to,
          keyword_limit: parseInt(this.project.project_detail.keyword_limit),
        };

        let api = process.env.VUE_APP_API_URL + "project-update";
        this.$http
          .post(api, param)
          .then((response) => {
            if (response.status == 200) {
              if (parseInt(this.project.project_detail.status) == 0) {
                this.allow_delete = true;
              } else {
                this.allow_delete = false;
              }
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Project berhasil diupdate!',
                  position: "top-right",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          })
          .catch((err) => {
            console.log(err);
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan, Silakan coba lagi!',
                position: "top-right",
                timeout: 5000,
                type: "danger",
              })
              .show();
          })
          .finally(() => {
            this.is_loading = false;
          });
      });
    },
    deleteProject: function() {
      let id = parseInt(this.id_project);
      swal({
        title: "Apakah anda yakin?",
        text:
          "Akan menghapus project ini. Pastikan status project dalam keadan Stop sebelum menghapus project.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yes) => {
        if (yes) {
          this.loading_text = "Menghapus Project";
          this.is_loading = true;
          this.loading_key++;

          let param = {
            _id: id,
          };
          let api = process.env.VUE_APP_API_URL + "project-delete";
          this.$http
            .post(api, param)
            .then((response) => {
              if (response.status == 200) {
                this.loading_text = "Project berhasil dihapus";
                this.is_loading = true;
                this.loading_key++;

                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Project berhasil dihapus!',
                    position: "top-right",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
                this.$router.push("/admin");
              } else {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                      response.data.status,
                    position: "top-right",
                    timeout: 5000,
                    type: "danger",
                  })
                  .show();
              }
            })
            .catch((error) => {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                    error.response.data.status,
                  position: "top-right",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    ubahGambar: function() {
      $("#logo_proyek").click();
    },
    previewFile: function(e) {
      let file = e.target.files[0];
      this.file_input = file;
    },
    uploadFile: function() {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("file", this.file_input);

        if (this.file_input == null) {
          resolve(null);
        } else {
          this.loading_text = "Mengunggah gambar...";
          this.loading_key++;

          let api = process.env.VUE_APP_API_URL + "upload";
          this.$http
            .post(api, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response.status == 200) {
                this.logo = response.data.filename;
                resolve(response.data.filename);
              } else {
                reject();
              }
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    toggleSNA: function() {
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
      };
      let api = process.env.VUE_APP_API_URL + "sna-toggle";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    toggleNER: function() {
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
      };
      let api = process.env.VUE_APP_API_URL + "ner-toggle";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    toggleQuote: function() {
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      if (this.project.project_detail.quotes_extraction == true) {
        toggle = 1;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
      };
      let api = process.env.VUE_APP_API_URL + "quote-toggle";
      this.$http
        .post(api, params)
        .then((response) => {
          if (this.setnotifv6 == false && response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    toggleTrending: function() {
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
      };
      let api = process.env.VUE_APP_API_URL + "twitter-trending-toggle";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    toggleCC: function() {
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
      };
      let api = process.env.VUE_APP_API_URL + "cc-toggle";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    toggleNewsTrend: function() {
      let api = process.env.VUE_APP_API_URL + "project-feature-toggle";
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      if(this.project.project_detail.news_trend == true) {
        toggle = 1;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
        name: "news_trend",
      };

      this.$http
        .post(api, params)
        .then((response) => {
          if (this.setnotifv6 == false && response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    toggleIG: function() {
      let api = process.env.VUE_APP_API_URL + "project-feature-toggle";
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
        name: "ig_comment",
      };

      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    toggleSearch: function() {
      let api = process.env.VUE_APP_API_URL + "project-feature-toggle";
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
        name: "search",
      };

      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    toggleGoogleSearch: function() {
      let api = process.env.VUE_APP_API_URL + "project-feature-toggle";
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
        name: "search_google",
      };

      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    toggleV6Access: function() {
      let api = process.env.VUE_APP_API_URL + "project-feature-toggle";
      let toggle = 0;
      if (this.$(event.target)[0].checked == true) {
        toggle = 1;
        this.project.project_detail.quotes_extraction = true;
        this.project.project_detail.news_trend = false;
      } else {
        this.project.project_detail.quotes_extraction = false;
        this.project.project_detail.news_trend = false;
      }

      let params = {
        _id: parseInt(this.id_project),
        value: toggle,
        name: "v6_access",
      };

      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.setnotifv6 = true;
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Fitur berhasil diupdate.',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
            
            this.toggleQuote();
            this.toggleNewsTrend();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status fitur.',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
       
        this.setnotifv6 = false;
    },
  },
  computed: {
    nama_proyek: function() {
      return this.project != null ? this.project.project_detail.name : "";
    },
    logo_project: function() {
      let img = "/assets/img/profiles/default.png";
      if (this.file_input != null) {
        img = URL.createObjectURL(this.file_input);
      } else {
        if (this.project) {
          if (
            this.project.project_detail.logo != null &&
            this.project.project_detail.logo != ""
          ) {
            img = this.project.project_detail.logo;
          }
        }
      }

      return img;
    },
  },
  created: function() {
    let api = process.env.VUE_APP_API_URL + "project-detail/" + this.id_project;
    this.$http
      .get(api)
      .then((response) => {
        if (response.status == 200) {
          this.project = response.data;
          if (parseInt(this.project.project_detail.status) == 0) {
            this.allow_delete = true;
          }
          let tab_data = [];
          tab_data["tipe"] = response.data.project_detail.tipe;
          let tabs = [];
          tabs.push({
            name: "Keyword",
            component: tab_keyword,
            icon_class: "bi bi-key",
            data: tab_data,
          });
          tabs.push({
            name: "User",
            component: tab_user,
            icon_class: "bi bi-person",
          });
          if (this.project.project_detail.tipe == 1) {
            tabs.push({
              name: "Manage Channel",
              component: () => import("@/views/pages/settings/Channel.vue"),
              icon_class: "bi bi-toggles2",
              data: [this.project.project_detail],
              no_refresh: true,
            });
          } else {
            tabs.push({
              name: "Sources dan Akun",
              component: tab_sources,
              icon_class: "bi bi-facebook icon-sidebar",
              data: [this.project.project_detail],
              no_refresh: true,
            });
          }
          tabs.push({
            name: "Log",
            component: modal_log,
            icon_class: "bi bi-list",
            data: [this.project.project_detail],
          });
          this.tabs = tabs;
          initDaterangeFilter2(
            this.project.project_detail.periode_from,
            this.project.project_detail.periode_to
          );
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  },
};
</script>

<style scoped>
select.form-control {
  -webkit-appearance: button;
  cursor: pointer;
}
.full-width .fa,
.full-width .fas,
.full-width .far {
  width: 30px;
}
.form-horizontal .form-group {
  border-bottom: none !important;
}
</style>
